module.exports = __webpack_public_path__ + "media/images/Kitchen Espresso Cabinets-5cb72477.webp";